import pieUsIcon from '~/assets/images/icons/pie_us.svg';
import pieIsraelIcon from '~/assets/images/icons/pie_israel.svg';

export const PIE_COUNTRY_ICONS = {
  he: pieIsraelIcon,
  en: pieUsIcon,
};
